import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';

export default class BalanceReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true,
			systemModuleId: 8,
			moduleAccessStatus: 1,
			type: this.getDefaultGuid(),
			status: 0,
			typeNumber: '',
			typeNumberTo: '',
			subNumber: '',
			subNumberTo: '',
			number: '',
			numberTo: '',
			fromDate: null,
			toDate: null,
			types: [],
			menuId: 54
		}
	}
	getDocumentTypes() {
		this.httpPost("api/v1/constant/list", {
			filters: {
				type: 4,
			}
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				this.state.types = data.records;
			});
	}
	componentDidMount() {
		this.httpPost("api/v1/common/check/module/access", {
			systemModuleId: this.state.systemModuleId
		})
		.then(data => {
			if (data.status === -1) window.location.href = "/login";
			this.state.moduleAccessStatus = data.status;
			this.getDocumentTypes();
			this.refreshData();
		});
	}
	refreshData(e, outputFormat = "json") {
		if (!this.isNull(e)) e.preventDefault();
		this.httpPost("api/v1/report/balance", {
			type: this.state.type,
			status: this.state.status,
			typeNumber: this.state.typeNumber,
			typeNumberTo: this.state.typeNumberTo,
			subNumber: this.state.subNumber,
			subNumberTo: this.state.subNumberTo,
			number: this.state.number,
			numberTo: this.state.numberTo,
			fromDate: this.convertMomentToDb(this.state.fromDate),
			toDate: this.convertMomentToDb(this.state.toDate),
			outputFormat
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					if (outputFormat == 'excel') this.downloadExcel(data.bs64);
					if (outputFormat == "json") {
						this.state.data = data;
					}
					this.setState({
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
		if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
		return <div>
			<div className="nk-content-body">
				<div className="nk-block-head nk-block-head-sm">
					<div className="nk-block-between">
						<div className="nk-block-head-content">
							<h3 className="nk-block-title page-title">ترازنامه</h3>
						</div>
						<div className="nk-block-head-content">
							<div className="toggle-wrap nk-block-tools-toggle">
								<a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
								<div className="toggle-expand-content" data-content="pageMenu">
									<ul className="nk-block-tools g-3">
										<li>
											<a onClick={e => this.refreshData(e, "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="nk-block">
					<div className="card card-bordered card-stretch">
						<div className="card-inner-group">
							<div className="card-inner position-relative card-tools-toggle">
								<div className="card-title-group">
									<form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
										<div className="form-inline flex-nowrap gx-3">
											<div className="form-wrap">
												<select defaultValue={this.state.status} onChange={e => this.state.status = parseInt(e.target.value)} className="form-control">
													<option value="0">همه اسناد</option>
													<option value="1">قطعی</option>
													<option value="2">موقت</option>
												</select>
											</div>
											<div className="form-wrap">
												<select defaultValue={this.state.type} onChange={e => this.state.type = e.target.value} className='form-control'>
													<option value={this.getDefaultGuid()}>همه انواع</option>
													{this.state.types.map(currency => <option value={currency.id}>{currency.name}</option>)}
												</select>
											</div>
											<div className="form-wrap">
												<DatePicker
													inputReadOnly={false}
													className="form-control persian-date ltr"
													placeholder={"از تاریخ"}
													isGregorian={false}
													showTodayButton={true}
													timePicker={false}
													onChange={(e) => { this.state.fromDate = e }}
													value={this.getFormatedDateForDatePicker(this.state.fromDate)}
												/>
											</div>
											<div className="form-wrap">
												<DatePicker
													inputReadOnly={false}
													className="form-control persian-date ltr"
													placeholder={"تا تاریخ"}
													isGregorian={false}
													showTodayButton={true}
													timePicker={false}
													onChange={(e) => { this.state.toDate = e }}
													value={this.getFormatedDateForDatePicker(this.state.toDate)}
												/>
											</div>
										</div>
										<div className="form-inline flex-nowrap gx-3 mt-2">
											<div className="form-wrap">
												<input className="form-control" defaultValue={this.state.number} onChange={e => this.state.number = e.target.value} placeholder="از شماره سند" type="text" />
											</div>
											<div className="form-wrap">
												<input className="form-control" defaultValue={this.state.numberTo} onChange={e => this.state.numberTo = e.target.value} placeholder="تا شماره سند" type="text" />
											</div>
											<div className="form-wrap">
												<input className="form-control" defaultValue={this.state.subNumber} onChange={e => this.state.subNumber = e.target.value} placeholder="از شماره فرعی" type="text" />
											</div>
											<div className="form-wrap">
												<input className="form-control" defaultValue={this.state.subNumberTo} onChange={e => this.state.subNumberTo = e.target.value} placeholder="تا شماره فرعی" type="text" />
											</div>
											<div className="form-wrap">
												<input className="form-control" defaultValue={this.state.typeNumber} onChange={e => this.state.typeNumber = e.target.value} placeholder="از شماره اختصاصی" type="text" />
											</div>
											<div className="form-wrap">
												<input className="form-control" defaultValue={this.state.typeNumberTo} onChange={e => this.state.typeNumberTo = e.target.value} placeholder="تا شماره اختصاصی" type="text" />
											</div>
											<div className="btn-wrap">
												<span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> نمایش</button></span>
											</div>
										</div>
									</form>
								</div>
							</div>
							<div className="card-inner p-0">
								<div className="flex g-2" style={{ "border-top": "2px solid whitesmoke" }} >
									<div className="col-sm-6">
										<div className="p-2" style={{ "background-color": "#EDF8ED" }} >
											<div>
												<div className="flex">
													<div className="col-md-6">
														<h4>دارایی ها</h4>
													</div>
													<div className="col-md-3">ابتدای دوره</div>
													<div className="col-md-3">انتهای دوره</div>
												</div>
											</div>
											{this.state.data.darayi.map(d => [
												<div>
													<div className="txt-bold" style={{ "border-top": "1px solid #abdeab", "border-bottom": "1px solid #abdeab" }} >
														<div className="col-md-12">{d.accountName}</div>
													</div>
												</div>
												,
												d.items.map(i => <div>
													<div className="flex">
														<div className="col-md-6">{i.accountName}</div>
														<div className="col-md-3">{this.money(i.start)}</div>
														<div className="col-md-3">{this.money(i.finish)}</div>
													</div>
												</div>)
											])}
											<div className="flex bg-success txt-bold" style={{ "margin-top": "10px", "margin-bottom": "-15px" }}>
												<div className="col-md-6">
													<h4>جمع دارایی ها</h4>
												</div>
												<div className={"col-md-3 " + (this.state.data.sumDarayiFirst < 0 ? "red" : "")}>{this.money(this.state.data.sumDarayiFirst)}</div>
												<div className={"col-md-3 " + (this.state.data.sumDarayi < 0 ? "red" : "")}>{this.money(this.state.data.sumDarayi)}</div>
											</div>

										</div>
									</div>
									<div className="col-sm-6" >
										<div className="p-2" style={{ "background-color": "#FFF1F2" }} >
											<div>
												<div className="flex">
													<div className="col-md-6">
														<h4>بدهی ها</h4>
													</div>
													<div className="col-md-3">ابتدای دوره</div>
													<div className="col-md-3">انتهای دوره</div>
												</div>
											</div>
											{this.state.data.bedehi.map(d => [
												<div>
													<div className="txt-bold" style={{ "border-top": "1px solid #abdeab", "border-bottom": "1px solid #abdeab" }} >
														<div className="col-md-12">{d.accountName}</div>
													</div>
												</div>
												,
												d.items.map(i => <div>
													<div className="flex">
														<div className="col-md-6">{i.accountName}</div>
														<div className="col-md-3">{this.money(i.start)}</div>
														<div className="col-md-3">{this.money(i.finish)}</div>
													</div>
												</div>)
											])}
											<div className="flex bg-danger txt-bold" style={{ "margin-top": "10px", "margin-bottom": "-15px" }} >
												<div className="col-md-6">مجموع بدهی ها</div>
												<div className={"col-md-3 " + (this.state.data.sumFirstBed < 0 ? "red" : "")}>{this.money(this.state.data.sumFirstBed)}</div>
												<div className={"col-md-3 " + (this.state.data.sumBed < 0 ? "red" : "")}>{this.money(this.state.data.sumBed)}</div>
											</div>
										</div>
										<div className="p-2 mt-4" style={{ "background-color": "#F4FDFF" }} >
											<h4>حقوق صاحبان سهام</h4>
											{this.state.data.sarmaye.map(d => [
												<div>
													<div className="txt-bold" style={{ "border-top": "1px solid #abdeab", "border-bottom": "1px solid #abdeab" }} >
														<div className="col-md-12">{d.accountName}</div>
													</div>
												</div>
												,
												d.items.map(i => <div>
													<div className="flex">
														<div className="col-md-6">{i.accountName}</div>
														<div className="col-md-3">{this.money(i.start)}</div>
														<div className="col-md-3">{this.money(i.finish)}</div>
													</div>
												</div>)
											])}
											<div className="flex bg-info txt-bold" style={{ "margin-bottom": "-15px" }} >
												<div className="col-md-6">حقوق صاحبان سهام</div>
												<div className={"col-md-3 " + (this.state.data.sumSahamFirst < 0 ? "red" : "")}>{this.money(this.state.data.sumSahamFirst)}</div>
												<div className={"col-md-3 " + (this.state.data.sumSaham < 0 ? "red" : "")}>{this.money(this.state.data.sumSaham)}</div>
											</div>
										</div>
									</div>
								</div>
								<div className="flex g-2 mt-2" style={{ "margin": "1px", "background-color": "rgb(95, 95, 95)", "color": "whitesmoke" }} >
									<div className="col-md-6">
										<span className="pull-right">جمع دارایی ها</span>
										<span className="pull-left">{this.money(this.state.data.sumDarayi)} {this.state.data.global.company.CurrencyUnit}</span>
									</div>
									<div className="col-md-6">
										<span className="pull-right">جمع بدهی ها و سرمایه</span>
										<span className="pull-left">{this.money(this.state.data.sumSaham + this.state.data.sumBed)} {this.state.data.global.company.CurrencyUnit}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				<div className="nk-content ">
					<div className="container-fluid">
						<div className="nk-content-inner">
							{this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.isEmpty(this.state.data.global.annuals) ? this.renderNoAnnual() : this.renderForm()}
						</div>
					</div>
				</div>,
				<Footer />,
			];

		return contents;
	}
}